<template>
  <div class="powerTc" >
    <div class="title">
      <span style="float: left;padding-left: 35px;padding-top: 10px">
        隐患列表
      </span>
      <span>
        <i class="el-icon-error" style="padding-right:21px;padding-top:15px;float: right;cursor:pointer;" @click="closeTc"></i>
      </span>
    </div>
    <div class="time-select">
      时间筛选:
      <el-date-picker
        v-model="month"

        size="large"
        value-format="yyyy-MM"
        type="month"
      >
      </el-date-picker>


    </div>
    <div class="list-table">
      <el-table :data="Risktable"  align="center">
        <el-table-column prop="deptName" align="center"  label= "单位名称"></el-table-column>
        <el-table-column prop="monitorName" align="center"  label= "监测点名称"></el-table-column>
        <el-table-column prop="mostSeriousRiskLevelName" align="center"  label= "隐患等级"></el-table-column>
        <el-table-column  align="center"  label= "隐患名称">
          <template slot-scope="scope">
            {{scope.row.alertLevelNames.join(',')}}
          </template>
        </el-table-column>

      </el-table>
    </div>

  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import {factors} from "@turf/turf";
import qs from "qs";
export default {
  name: "leftPage",
  props: {

    alertLevel: {
      type: Number,
      default() {
        return '';
      }
    },
  },
  data() {
    return {
      showTc:false,
      Risktable:[],
      depid:null,
      month:null,
    };
  },
  methods: {
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;
      var time = "";
      time =
        year + "-" + month + "-" + date ;



      this.month=year + "-" + month



    },
    getRiskList(page){

      let param = {};
      param.method = "post";
      param.url = "/portal/historyRisks";
      param.data = {
        deptId:this.depid,
        yearMonth:this.month
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {

          this.Risktable=res.data

        }
      });
    },

    closeTc(){
      Bus.$emit('colsetc',false )
    },

  },
  mounted() {
    let that=this
    this.getnowtime()
    this.getRiskList()

    Bus.$on('changeid',(val)=>{
      this.depid=val.deptId
      that.getRiskList()
    })


  },
  watch:{
    month(){
      this.getRiskList()
    }
  },
  components: {

  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.powerTc{
  width: 100%;
  height: 100%;
  background-color: #0C213F;
}
.time-select{
  height:60px;
  float:right;
  margin-right:40px;
  color: #fff;
  font-size: 18px;
  margin-top: 10px;
}
.list-table{
  clear:both;
  margin: 14px 20px;
  height: 452px;
  overflow: auto;
}
//.left{
//  width: 428px;
//  height: 419px;
//  border: 1px solid #0B47A5;
//  //position: relative;
//  //left:72px;
//  //top: 270px;
//}
.title{
  height: 45px;
  width: 100%;
  background-color: rgba(61, 130, 234, 0.4);
  font-size: 16px;
  font-family: PingFang;
  color: #6CBCFD;
  line-height: 24px;
  letter-spacing: 2px;
}
.use-sum{
  width: 268px;
  height: 45px;
  font-size: 14px;
  font-family: PingFang;
  color: rgba(255, 169, 64, 0.8);
  line-height: 20px;
  letter-spacing: 2px;
  padding-top: 14px;
  padding-left:34px;
  position: relative;
  top:22px;
}
.text-style{
  font-size: 14px;
  font-family: PingFang;
  color: rgba(108, 188, 253, 0.8);
  line-height: 20px;
  letter-spacing: 2px;
  position: absolute;
  top:152px;
  left:34px;
}
.rectangle{
  display: inline-block;
}
.square{
  display: inline-block;
  width: 14px;
  height: 14px;
  background: rgba(11, 71, 165, 0.5);
  border: 1px solid #0B47A5;
}
.text1{
  padding-left:14px;
  display: inline-block;
  font-size: 12px;
  font-family: PingFang;
  color: #6CBCFD;
  line-height: 17px;
  letter-spacing: 1px;
}
.text2{
  position: absolute;
  left:268px;
  display: inline-block;
  font-size: 16px;
  font-family: Alternate;
  font-weight: bold;
  color: #6CBCFD;
  line-height: 19px;
  letter-spacing: 2px;
}
.text3{
  position: absolute;
  left:360px;
  display: inline-block;
  font-size: 16px;
  font-family: Alternate;
  color: #6CBCFD;
  line-height: 19px;
  letter-spacing: 2px;
}
.warm-type{
  display: inline-block;
  vertical-align: top;
  width: 370px;
  height: 160px;
  margin-left: 23px;
}
.warm-list{
  display: inline-block;
  vertical-align: top;
  width: 150px;
  height: 160px;
  margin-left: 23px;
}
.btn-list{
  float: right;
  margin-right: 37px;
  color: #6CBCFD;
  font-size: 14px;
  text-align: center;
  .btn-item{
    width: 36px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
  }
  .disnone{
    display: none;
  }
  .blue-blank{

    width: 36px;
    height: 3px;
    background-color: #6CBCFD;
    position: relative;
    top: 2px;

  }
}
.btn-left-list{

  color: #6CBCFD;
  font-size: 14px;
  width: 100px;
  display: inline-block;
  .btn-item{
    width: 36px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
  }
  .disnone{
    display: none;
  }
  .blue-blank{

    width: 36px;
    height: 3px;
    background-color: #6CBCFD;
    position: relative;
    top: 2px;

  }
}
.time-blank{
  float: right;
}
</style>
<style>
#app .login-wrap .time-blank .el-date-editor.el-input__inner, #app .time-blank .el-date-editor > .el-input__inner{
  background-color: #0C213F;
  color: #6CBCFD;
  border: 1px solid #0B47A5;
}
#app .time-blank .el-input__prefix, .el-input__suffix{
  color: #6CBCFD;

}
</style>

